import { $api } from '@/services/api/apiService'
import { mapState } from 'pinia'
import { mainStore } from '@/stores/datas.js'

export default {
  data: () => ({
  }),
  watch: {
    $user: {
      handler(user, old) {
        if ((!old && user) || (user && user.api_token != old.api_token)) {
          this.$api.setApiToken(user.api_token)
        }
      },
      immediate: true
    }
  },
  computed: {
    $api: () => $api,

    $store: () => mainStore(),

    ...mapState(mainStore, {
      $user: 'user'
    }),
    ...mapState(mainStore, {
      $campaign: 'campaign'
    }),
    ...mapState(mainStore, {
      $template: 'template'
    }),
    ...mapState(mainStore, {
      $mecanic: 'mecanic'
    }),
    ...mapState(mainStore, {
      $messageError: 'messageError'
    }),

    baseUrl() {
      const urlApi = window.location.href.includes('digiworks')
        ? 'https://api.' + window.location.hostname
        : 'https://api3.offres-delices.com'
      return import.meta.env.MODE === 'production'
        ? urlApi
        : import.meta.env.VITE_BASE_URL_DEV
    }
  },
  methods: {
    imgUrl(name, path) {
      if (name && path) {
        return this.baseUrl + '/storage/' + path + '/' + name
      } else {
        return ''
      }
    },
    attachEventListeners() {
      const elementsArray = document.querySelectorAll('.winner-modal')
      elementsArray.forEach(function (elem) {
        elem.addEventListener('click', function () {
          mainStore().setWinnersModal(true)
        })
      })

      const elementsArrayReglement = document.querySelectorAll('.reglement-modal')
      elementsArrayReglement.forEach((elem) => {
        elem.addEventListener('click', () => {
          mainStore().setReglementModal(true, {
            title: 'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
            message: this.$template?.rules ?? '',
            img: this.$template?.rules_picture ?? ''
          })
        })
      })
    },
    tagText(text, voucher) {
      if (this.$user && text) {
        text = text.replace(/\[PRENOM\]/g, this.$user.first_name);
        text = text.replace(/\[NOM\]/g, this.$user.last_name);
        text = text.replace(/\[CIVILITE\]/g, this.$user.gender_id === 1
          ? 'MME'
          : this.$user.gender_id === 2
            ? 'M'
            : '');
      }

      if (text) {
        text = text.replace(/\[WINNERS,\s*(.+?)\]/g, (match, p1) => {
          return `<span class="underline winner-modal cursor-pointer">${p1}</span>`;
        });
      }

      if (text) {
        text = text.replace(/\[REGLEMENT,\s*(.+?)\]/g, (match, p1) => {
          return `<span class="underline reglement-modal cursor-pointer">${p1}</span>`;
        });
      }

      if (voucher) {
        text = text.replace(/\[BON\]/g, voucher?.value ? `${voucher.value} €` : '')
      }

      this.$nextTick(() => {
        this.attachEventListeners();
      });

      return text;
    }
  }
}
